module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/camera_country_house-89768ad2c6eba8d1286bcfae62ad131c.png";